import ForcePasswordModal from '@/components/ForcePasswordModal';
import SiderMenu from '@/components/SiderMenu';
import getPageTitle from '@/utils/getPageTitle';
import { Layout, Spin, notification } from 'antd';
import { connect } from 'dva';
import React from 'react';
import { ContainerQuery } from 'react-container-query';
import DocumentTitle from 'react-document-title';
import Media from 'react-media';
import logo from '../assets/logo.png';
import EmailNotVerified from '../components/EmailNotVerified/EmailNotVerified';
import UniversalDrawer from '../components/UniversalDrawer/Index';
import TabAlert from '@/components/TabAlert/TabAlert';
import styles from './BasicLayout.less';
import Footer from './Footer';
import Header from './Header';
import Context from './MenuContext';
import moment from 'moment';
import LogRocket from 'logrocket';
import AWS from '../components/MarketPlace/AWSMarketPlace';
import { firebase, firestore } from '../utils/firebase';
import PageLoading from '@/components/PageLoading';
import classNames from 'classnames';
import SettingDrawer from '../components/SettingDrawer/index';
import Exception from '@/components/Exception';
import { PATH_DASHBOARD } from '@/utils/routes/path';
import IntroductionCarousel from '@/components/IntroductionCarousel/IntroductionCarousel';

const enabledLogRocketForEnv = ['beta', 'prod'];

moment.locale('en-US');

// * enable logrocket for dev and prod env only for now we can enable for other envs later
if (enabledLogRocketForEnv.includes(APP_ENV)) {
  LogRocket.init('lxac50/cloudnosys');
}
// // lazy load SettingDrawer
// const SettingDrawer = React.lazy(() => import('@/components/SettingDrawer'));

const { Content } = Layout;

const query = {
  'screen-xs': {
    maxWidth: 575,
  },
  'screen-sm': {
    minWidth: 576,
    maxWidth: 767,
  },
  'screen-md': {
    minWidth: 768,
    maxWidth: 991,
  },
  'screen-lg': {
    minWidth: 992,
    maxWidth: 1199,
  },
  'screen-xl': {
    minWidth: 1200,
    maxWidth: 1599,
  },
  'screen-xxl': {
    minWidth: 1600,
  },
};
@connect(({ notifications, user, cloudAccount, global, login, accessControl }) => ({
  notifications: notifications.list,
  accessControl: accessControl.list,
  selectedCloudAccounts: cloudAccount.selectedCloudAccounts,
  allCloudAccountsList: cloudAccount.allCloudAccountsList,
  user: user.currentUser,
  authority: user.authority,
  hideMenuForPlaybook: global.hideMenuForPlaybook,
  loaderStatus: login.loaderStatus,
  isUserVerifying: user.isUserVerifying,
}))
class BasicLayout extends React.Component {
  state = {
    loaderForMarketPlace: false,
    countForAwsMarketNotification: 0,
    loaderStatus: false,
    updateEmailCouter: 0,
    isOffline: false,
  };

  constructor(props) {
    super(props);
    // Bind the debounced function to ensure 'this' context is correct
    this.updateLastActiveTime = this.debounce(this.updateLastActiveTime.bind(this), 60000);
  }

  async componentDidMount() {
    const { dispatch } = this.props;
    this.updateLastActiveTime();
    dispatch({
      type: 'user/fetchCurrent',
    });
    const {
      currentUser,
      currentOrganisation,
      route: { routes, path, authority },
    } = this.props;
    //get url and check either userId exist or not
    let url_string = window.location.href;
    let url = new URL(url_string);
    let subscriptionCustomerId = url.searchParams.get('subscriptionCustomerId');
    let id = '';

    if (subscriptionCustomerId) {
      notification.open({
        message: 'Checking AWS market place status',
        description: '',
        onClick: () => {},
      });
      id = subscriptionCustomerId;
      this.setState({ loaderForMarketPlace: true, loaderStatus: true });
      let payloadOfId = { id };

      dispatch({
        type: 'login/checkMarketPlaceStatus',
        payload: payloadOfId,
      });
    }
    this.setCurrentVersion();

    dispatch({
      type: 'editor/getTemplateList',
    });
    dispatch({
      type: 'global/getRbacRoles',
    });

    dispatch({
      type: 'global/getGlobalCategories',
    });

    dispatch({
      type: 'global/getModalData',
    });

    dispatch({
      type: 'signatureMetaData/fetchMetaData',
    });

    dispatch({
      type: 'customSignatures/list',
    });

    dispatch({
      type: 'regulations/getAllRegulations',
    });

    dispatch({
      type: 'setting/getSetting',
    });

    dispatch({
      type: 'menu/getMenuData',
      payload: { routes, path, authority },
    });

    if (currentUser.id) {
      this.getOrgs();
    }

    if (currentOrganisation && currentOrganisation.id) {
      dispatch({
        type: 'accessControl/list',
        payload: {
          params: {
            orgId: currentOrganisation.id,
          },
        },
      });
      await this.getCloudAccounts();
    }

    document.addEventListener('mousemove', this.updateLastActiveTime);
    document.addEventListener('click', this.updateLastActiveTime);
    document.addEventListener('keypress', this.updateLastActiveTime);

    window.addEventListener('online', this.onConnectionOnline);
    window.addEventListener('offline', this.onConnectionOffline);
  }

  async componentDidUpdate(prevProps) {
    const {
      dispatch,
      currentUser,
      authority,
      currentOrganisation,
      allCloudAccountsList,
      selectedCloudAccounts,
      route: { routes, path },
      user,
      accessControl,
    } = this.props;
    if (user?.email && !firebase.auth()?.currentUser?.email) {
      dispatch({
        type: 'login/logout',
      });
    }
    // if (currentUser.lastActive && currentUser.lastActive < new Date().getTime() - 10800000) {
    //   dispatch({
    //     type: 'login/logout',
    //   });
    // }
    if (user?.email && firebase.auth()?.currentUser?.email) {
      if (user.email !== firebase.auth().currentUser.email && this.state.updateEmailCouter === 0) {
        dispatch({
          type: 'user/checkEmail',
          payload: {
            email: firebase.auth().currentUser.email,
            message: true,
          },
        });
        this.setState({ updateEmailCouter: 1 });
      }
    }
    if (prevProps.accessControl !== accessControl) {
      dispatch({
        type: 'cloudAccount/list',
        payload: {
          params: {
            orgId: currentOrganisation?.id,
          },
        },
      });
    }
    if (!prevProps.currentOrganisation && currentOrganisation) {
      dispatch({
        type: 'editor/getPlaybooksNodesConfig',
      });
    }
    if (prevProps?.currentOrganisation?.id !== currentOrganisation?.id) {
      if (currentUser) {
        LogRocket.identify(currentUser?.uid, {
          name: currentUser.name,
          email: currentUser.email,
          // Add your own custom user variables here, ie:
          subscriptionType: 'pro',
        });
        dispatch({
          type: 'accessControl/list',
          payload: {
            params: {
              orgId: currentOrganisation?.id,
            },
          },
        });
        dispatch({
          type: 'login/changeUserRole',
          payload: currentUser.id,
        });
        dispatch({
          type: 'customSignatures/list',
        });
      }
      this.getCloudAccounts();

      // TODO: As this is one time fetch so it should only be in CDM
      // dispatch({
      //   type: 'signatureMetaData/fetchMetaData',
      // });
    }

    //? _____________ Calling resources reports function whenever there is a change on account selection _____________
    if (prevProps.selectedCloudAccounts.length !== selectedCloudAccounts.length) {
      await this.getResourcesReport();
    }

    if (!prevProps.currentUser.id && currentUser.id) {
      this.getOrgs();
    }

    if (prevProps.authority !== authority) {
      dispatch({
        type: 'menu/getMenuData',
        payload: { routes, path, authority },
      });
    }

    if (
      prevProps.selectedCloudAccounts.length !== selectedCloudAccounts.length &&
      currentOrganisation &&
      currentOrganisation.id
    ) {
      dispatch({
        type: 'scopeReport/current',
      });
    }
  }

  componentWillUnmount() {
    const { dispatch } = this.props;

    dispatch({
      type: 'CANCEL_WATCH/cloudAccount',
    });

    dispatch({
      type: 'CANCEL_WATCH_read/accessControl',
    });

    dispatch({
      type: 'unsub/user',
    });

    dispatch({
      type: 'CANCEL_WATCH_list/organisation',
    });

    dispatch({
      type: 'CANCEL_WATCH_SP_RISKS/organisation',
    });

    window.removeEventListener('online', this.onConnectionOnline);
    window.removeEventListener('offline', this.onConnectionOffline);
  }

  setCurrentVersion = () => {
    const { dispatch } = this.props;

    dispatch({
      type: 'login/checkVersionInfo',
    });
  };

  getResourcesReport = async () => {
    const {
      allCloudAccountsList,
      selectedCloudAccounts,
      currentOrganisation,
      dispatch,
    } = this.props;

    // dispatch({
    //   type: 'resourcesReport/checkSubscriptionUpdation',
    // });
    await dispatch({
      type: 'resourcesReport/getReport',
      payload: {
        orgId: currentOrganisation?.id,
        cloudAccounts: selectedCloudAccounts.map(v => v.id),
      },
    });
  };

  onConnectionOnline = () => {
    notification.close('offlineNotification');
    if (this.state.isOffline)
      notification.success({
        message: 'You are online!',
        key: 'onlineNotifcation',
        placement: 'bottomRight',
      });
    this.setState({ isOffline: false });
  };

  onConnectionOffline = () => {
    notification.close('onlineNotifcation');
    notification.error({
      message: "We're having trouble connecting. Please check your connection.",
      key: 'offlineNotification',
      duration: 0,
      placement: 'bottomRight',
    });
    this.setState({ isOffline: true });
  };

  getCloudAccounts = async () => {
    const { dispatch, currentOrganisation } = this.props;
    if (currentOrganisation) {
      dispatch({
        type: 'organisation/fetchSPRisks',
      });
      await dispatch({
        type: 'cloudAccount/list',
        payload: {
          params: {
            orgId: currentOrganisation.id,
          },
        },
      });
      dispatch({
        type: 'customRegulations/list',
        payload: {
          params: {
            orgId: currentOrganisation.id,
          },
        },
      });

      dispatch({
        type: 'cloudAccount/save',
        payload: {
          finalProgress: 0,
        },
      });
    }
  };

  getOrgs = () => {
    const { dispatch, currentUser } = this.props;
    dispatch({
      type: 'organisation/fetchList',
      payload: {
        params: {
          userId: currentUser.id,
          limit: 50,
        },
      },
    });
  };

  getContext() {
    const { location, breadcrumbNameMap } = this.props;
    return {
      location,
      breadcrumbNameMap,
    };
  }

  getLayoutStyle = () => {
    const { fixSiderbar, isMobile, collapsed, layout, hideMenuForPlaybook } = this.props;
    if (fixSiderbar && layout !== 'topmenu' && !isMobile) {
      return {
        paddingLeft:
          collapsed && !hideMenuForPlaybook
            ? '80px'
            : !collapsed && hideMenuForPlaybook
            ? '0px'
            : '250px',
      };
    }
    return null;
  };

  handleMenuCollapse = collapsed => {
    const { dispatch } = this.props;
    dispatch({
      type: 'global/changeLayoutCollapsed',
      payload: collapsed,
    });
  };

  renderDrawers = () => {
    return (
      <>
        <UniversalDrawer history={this.props.history} />
      </>
    );
  };
  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  async updateLastActiveTime() {
    try {
      if (!this.props.currentUser || !this.props.currentUser?.uid) {
        console.error('currentUser or currentUser.uid is undefined.');
        return;
      }
      const currentTime = new Date().getTime();
      const userRef = firestore.collection('Users').doc(this.props.currentUser?.uid);

      await userRef.update({
        lastActive: currentTime,
      });
    } catch (error) {
      console.error('Error updating last active time: ', error);
    }
  }

  render() {
    const {
      navTheme,
      layout: PropsLayout,
      children,
      location: { pathname },
      isMobile,
      menuData,
      breadcrumbNameMap,
      fixedHeader,
      currentOrganisation,
      hideMenuForPlaybook,
      organisationLoading,
      authority,
      whiteLabel,
    } = this.props;

    if (
      this.props.loaderStatus &&
      this.state.loaderStatus &&
      this.state.countForAwsMarketNotification === 0
    ) {
      this.setState({ countForAwsMarketNotification: 1 });
      return <AWS status={this.state.loaderForMarketPlace} />;
    }
    if (
      this.props.currentUser &&
      this.props.currentUser.Role === 'CHILD_USER' &&
      this.props.currentUser.ChangeAutoGeneratePassword === false
    ) {
      // need to generate new pw
      // show modal
    }

    const isTop = PropsLayout === 'topmenu';
    const contentStyle = !fixedHeader ? { paddingTop: 0 } : {};
    const { isVerified } = this.props.user;
    const { dispatch, isUserVerifying, currentUser, packageExpiry } = this.props;

    if (isVerified === undefined) {
      return null;
    }
    if (isVerified) {
      dispatch({
        type: 'user/setVerifyingState',
        payload: false,
      });
    }
    const tabProps = {
      description:
        'Check your inbox for a verification email and confirm your email address to access all the features',
      type: 'email',
      text: 'Resend Email',
    };
    let accountDisabled = false;
    if (authority !== 'user') {
      accountDisabled = true;
    }

    const currentUrl = new URL(window.location.href);

    const allowedPaths = [
      PATH_DASHBOARD.monitoring.root,
      PATH_DASHBOARD.monitoring.securityDashboard,
      PATH_DASHBOARD.monitoring.complianceDashboard,
    ];
    const expiredOrgAccessiblePath =
      allowedPaths.includes(currentUrl.pathname) && currentUrl.search === '';

    const layout = (
      <Layout>
        {isTop && !isMobile ? null : hideMenuForPlaybook ? null : (
          <SiderMenu
            logo={logo}
            theme={navTheme}
            onCollapse={this.handleMenuCollapse}
            menuData={menuData}
            isMobile={isMobile}
            {...this.props}
          />
        )}
        <Layout
          style={{
            ...this.getLayoutStyle(),
            minHeight: '100vh',
          }}
        >
          <Content className={styles.content} style={contentStyle}>
            <div>
              {packageExpiry === 'expired' &&
              !expiredOrgAccessiblePath &&
              currentUser.email !== 'support@cloudnosys.com' ? (
                <Exception
                  type="403"
                  backText="See Dashboard"
                  desc="Your trial is expired. Please contact support."
                />
              ) : (
                <div>
                  {isVerified && !isUserVerifying ? (
                    <div>
                      {(currentOrganisation || pathname.match(/invite/gi)) &&
                        accountDisabled &&
                        children}
                      {currentOrganisation && this.renderDrawers()}
                    </div>
                  ) : isUserVerifying ? (
                    <div>
                      <PageLoading />
                      <div style={{ textAlign: 'center', padding: '50px' }}>
                        Please wait, confirming your account verification.
                      </div>
                    </div>
                  ) : (
                    <div>
                      <TabAlert {...tabProps} />
                      <EmailNotVerified />
                    </div>
                  )}
                </div>
              )}
            </div>
          </Content>
          {/* <Footer {...whiteLabel} /> */}
        </Layout>
      </Layout>
    );

    return (
      <div>
        <SettingDrawer />
        <React.Fragment>
          <DocumentTitle title={getPageTitle(pathname, breadcrumbNameMap)}>
            <ContainerQuery query={query}>
              {params => (
                <Context.Provider value={this.getContext()}>
                  {!hideMenuForPlaybook && (
                    <Header
                      menuData={menuData}
                      handleMenuCollapse={this.handleMenuCollapse}
                      logo={logo}
                      isMobile={isMobile}
                      {...this.props}
                    />
                  )}

                  <div className={classNames(params)}>{layout}</div>
                  <ForcePasswordModal />
                  <IntroductionCarousel />
                </Context.Provider>
              )}
            </ContainerQuery>
          </DocumentTitle>
        </React.Fragment>
      </div>
    );
  }
}

export default connect(
  ({ cloudAccount, global, setting, menu: menuModel, organisation, user, login }) => ({
    authority: user.authority,
    cloudAccounts: cloudAccount.allCloudAccountsList,
    selectedCloudAccounts: cloudAccount.selectedCloudAccounts,
    currentUser: user.currentUser,
    collapsed: global.collapsed,
    whiteLabel: login.whiteLabel,
    layout: setting.layout,
    menuData: menuModel.menuData,
    breadcrumbNameMap: menuModel.breadcrumbNameMap,
    currentOrganisation: organisation.current,
    organisationLoading: organisation.loading,
    packageExpiry: organisation.packageExpiry,
    ...setting,
  })
)(props => (
  <Media query="(max-width: 599px)">
    {isMobile => <BasicLayout {...props} isMobile={isMobile} />}
  </Media>
));
